import React from "react";
import { useTranslation } from "react-i18next";
import { Button } from "../../../components/forms/Buttons/Button";
import {
  ArrowUpTrayIcon,
  EyeSlashIcon,
  EyeIcon,
} from "@heroicons/react/24/outline";
// import { toast } from "react-toastify";
// import { postDistributeSeats } from "../../../services/olympiad/teamMemberService";
import { useNavigate } from "react-router-dom";
import { publishResults } from "../../../services/olympiad/results";
import { toast } from "react-toastify";
import ExportExcel from "./ExportExcel";

export default function ResultsPageHeader({ isExamCenterAdmin, filterParams }) {
  const [t] = useTranslation();
  const navigate = useNavigate();

  const handlePublishToggle = (isPublished) => {
    const action = isPublished ? "publish" : "unpublish";
    const toastId = `${action}-results`;
    if (toast.isActive(toastId)) return;

    toast(
      <div className="flex flex-col gap-3 pt-1">
        <p className="font-medium">
          {t(
            `admin.${action}_results_confirm`,
            `Are you sure ${action} results?`
          )}
        </p>
        <div className="flex justify-end gap-2">
          <Button
            text={t("buttons.cancel")}
            color="secondary"
            onClick={() => toast.dismiss(toastId)}
          />
          <Button
            text={t("buttons.confirm", "Confirm")}
            color="primary"
            onClick={() => {
              publishResults(
                { is_published: isPublished },
                { ...filterParams, ordering: null }
              )
                .then((res) => {
                  toast.dismiss(toastId);
                  toast.success(
                    `Results ${action}ed for ${res.team_updated} teams, ${res.updated_count} students`
                  );
                })
                .catch((err) => {
                  toast.dismiss(toastId);
                  toast.error(
                    err.response?.data?.detail ||
                      t(
                        `admin.${action}_results_error`,
                        `Error ${action}ing results`
                      )
                  );
                });
            }}
          />
        </div>
      </div>,
      { hideProgressBar: true, toastId }
    );
  };

  return (
    <div className="mb-4 flex items-center justify-between">
      <h1 className="text-2xl font-bold">{t("admin.teams")}</h1>
      <div className="flex items-center gap-2">
        {isExamCenterAdmin ? (
          <Button
            Icon={ArrowUpTrayIcon}
            text="Загрузить результаты"
            onClick={() => {
              navigate("/admin/results/upload");
              console.log("upload results");
            }}
            color="primary"
          />
        ) : (
          <>
            <Button
              Icon={EyeIcon}
              text="Publish"
              onClick={() => handlePublishToggle(true)}
              color="primary"
            />
            <Button
              Icon={EyeSlashIcon}
              text="Unpublish"
              onClick={() => handlePublishToggle(false)}
              color="primary"
            />
            <ExportExcel params={filterParams} />
          </>
        )}
      </div>
    </div>
  );
}
